import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { pushToEventDetail } from '../../liveRouting';
import { ApplicationStoreKey, IApplicationStore } from '../../liveStores';

import { FooterContainer } from '../footer/footerContainer';

import { ProgressContent } from 'common--design-library';
import { SimpleBarWrapper, CalendarList, DayFilterComponent, SportSelection } from 'desktop--design-library';
import { evalFooterVisibility } from 'eTip--common';

export interface ICalendarProps {
    applicationStore: IApplicationStore
}

@inject(ApplicationStoreKey)
@observer
export class CalendarRouteContainer extends React.Component<ICalendarProps> { // EtipComponentBase<ICalendarProps> {
    constructor(props: ICalendarProps) {
        super(props);
    }

    componentWillMount() {
        this.props.applicationStore.setCanShowLeftColumn(true);

        this.store.loadAsync(true, this.store.currentDate);
    }

    componentWillReceiveProps(_nextProps: ICalendarProps) {
        //TODOHL
    }

    get store() {
        return this.props.applicationStore.calendar;
    }

    processDateChange(item: Date) {
        if (this.store.currentDate != item) {
            this.store.setDateFilter(item);
            this.store.loadAsync(true, item);
        }
    }

    render() {
        return (
            <SimpleBarWrapper className="h-100" forceVisible={true} scrollToTop>
                <DayFilterComponent
                    availableDates={[...this.store.datesToFilter]}
                    selectedDate={this.store.currentDate}
                    onDateSelect={(dateToSelect: Date) => { this.processDateChange(dateToSelect) }}
                />

                <ProgressContent state={this.store.state}>
                    <>
                        <SportSelection
                            className="my-2"
                            sports={this.store.availableSports}
                            selectedSports={this.store.selectedSportIds}
                            selectSport={(sportCategoryId: number) => {
                                this.store.toggleSport(sportCategoryId)
                            }}
                            favoritesCategoryId={null}
                            videosCategoryId={null}
                            matchTrackersCategoryId={null}
                        />
                        <CalendarList items={[...this.store.filteredEvents]}
                            canShowLinkForLiveOnly={true}
                            onGoToDetail={(eventId: number) => { pushToEventDetail(eventId, false, false, true) }}
                        />
                    </>
                </ProgressContent>
                <FooterContainer canShow={evalFooterVisibility(this.store.state)} />
            </SimpleBarWrapper>
        );
    }
}
